<div class="modal" id="dragDropModal" tabindex="-1" role="dialog" aria-labelledby="dragDropModal" aria-hidden="true">
    <div class="component-container model-content ">
        <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <img src="/assets/images/icons/close_c.svg" alt="" />
                <p>Close</p>
            </button>
        </div>
        <div class="align-self-center text-center text-uppercase drag-container">
            <div>
                <h1>Now upload or drag & drop</h1>
                <h2>Driver’s license (or equivalent ID)</h2>
            </div>
            <div class="dashed-container m-auto col-sm-8" appDnd (fileDropped)="onFileDropped($event)">
                <img src="/assets/images/icons/upload_logo.svg" alt="" />
                <p class="mt-3">JPG, PNG or PDF, smaller than 10MB</p>
                <p>Drag and drop your image here or</p>
                <input type="file" accept=".png, .jpg, .pdf" class="file-select btn btn-primary" id="fileFront"
                    name="fileFront" (change)="fileChangeEvent($event.target.files)" #fileDropRef>
                <div class="mt-2">
                    <span>{{file?.name}}</span>
                </div>
            </div>
        </div>
        <div class="text-center bottom-container ">
            <button [disabled]="!file" (click)="onDone()" class="btn btn-primary btn-lg">Done</button>
        </div>
    </div>
</div>